<template>
  <div class="wiki-header">
    <div class="l-wrapper">
      <a v-if="isHeroGame" class="hero-logo" href="/"></a>
      <a v-else class="gamekee-logo" :href="`//www.${wikiDomain}`"></a>
      <div v-if="!isHeroGame" class="nav">
        <template v-for="(item,index) in navGroup">
          <a :key="index" :href="`//www.${wikiDomain + item.url}`">{{item.text}}</a>
        </template>
        <router-link to="/admin_www" v-if="isWww && $hasPermission('www_manage')">后台编辑</router-link>
      </div>
      <router-link to="/">
        <el-button v-if="$route.name.includes('User')" class="go-home-btn" type="primary">返回wiki</el-button>
      </router-link>
    </div>
    <div v-if="needLogin || loginUser.is_super" class="r-wrapper">
      <div v-if="!['wikiList','wwwSearch'].includes($route.name)" class="search-box">
        <input v-model="kw" placeholder="搜你所想" type="text" @keyup.enter="onSearch">
        <i class="el-icon el-icon-search" @click="onSearch"></i>
      </div>
      <div class="apply-wiki-btn" @click="onShowDg">
        <i class="wiki-icon wiki-icon-www-index-9 mR3"></i>
        申请wiki</div>
      <template v-if="loginUid>0">
        <div class="user-box">
          <el-dropdown placement="bottom" @command="onCommand">
            <a class="el-dropdown-link user">
              <img :src="handleImgSize(loginUser.avatar)" alt="">
              <span>{{ loginUser.username }}</span>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="goUserCenter">个人中心</el-dropdown-item>
              <el-dropdown-item command="loginOut"><span style="color: orangered;">退出登录</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <router-link class="msg-btn"  to="/msg/1">消息<span
          v-if="redPoint.total>0">{{ redPoint.total > 99 ? '99+' : redPoint.total }}</span></router-link>
      </template>
      <template v-else>
        <a @click="onShowLogin">注册/登录</a>
      </template>
    </div>
    <apply-wiki-dg ref="applyWikiDg"/>
  </div>
</template>

<script>
  import Login from '@/layout/wiki/components/login';
  import { mapActions, mapGetters } from 'vuex';
  import eventBus from '@/plugins/eventBus';
  import SvgIcon from '../../../components/SvgIcon/svgIcon';
  import ApplyWikiDg from '@/views/wiki/components/applyWikiDg.vue';

  export default {
    name: 'wikiHeader',
    mixins: [],
    props: {},
    model: {},
    components: {
      ApplyWikiDg,
      SvgIcon,
      Login
    },
    data () {
      return {
        isShowLogin: false,
        kw: '',
        navGroup:[
          {text:'热门wiki',url:'/wikis'},
          {text:'新游专区',url:'/games'},
          {text:'最新wiki',url:'/wikis'},
          {text:'游戏情报',url:'/news'},
          {text:'游戏视频',url:'/video'},
        ]
      };
    },
    computed: {
      ...mapGetters(['loginUid', 'loginUser', 'redPoint', 'gameInfo'])
    },
    methods: {
      ...mapActions(['loginOut']),
      onShowDg(){
        this.$refs.applyWikiDg.visible=true;
      },
      onSearch () {
        window.location.href = `//www.${this.wikiDomain}/search?kw=` + (this.kw || '');
        // if (this.isWww) {
          // window.location.href = `//www.${this.wikiDomain}/search?kw=` + (this.kw || '');
        // } else {
        //   window.location.replace(`${this.gameInfo.alias}/list?kw=${this.kw || ''}`)
        // }
      },
      onShowLogin () {
        eventBus.$emit('onShowLogin');
      },
      goUserCenter () {
        let { $route } = this;
        console.log($route);
        if (!$route.name.includes('wikiUser')) {
          window.open('/user/index/' + this.loginUid + '.html');
        } else {
          window.location.replace('/user/index/' + this.loginUid + '.html');
        }
      },
      onCommand (command) {
        if (command == 'loginOut') {
          this[command]('goHome');
        } else {
          this[command]();
        }
      }
    },
    watch: {},
    created () {
    },
    mounted () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    }
  };
</script>

<style lang="less" scoped>
.wiki-header {
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #404040;
  position: fixed;
  z-index: @middle-z-index;
  top: 0;
  left: 0;

  .l-wrapper {
    display: flex;
    align-items: center;

    .gamekee-logo {
      width: 150px;
      height: 30px;
      background: url("./../../../assets/images/logo3.png") no-repeat center;
      background-size: 100% auto;
      margin-left: 32px;
      margin-right: 12px;
    }

    .hero-logo {
      width: 150px;
      height: 50px;
      background: url("./../../../assets/images/hero_logo.png") no-repeat left center;
      background-size: auto 50px;
      margin-left: 32px;
      margin-right: 12px;
    }

    .go-home-btn {
      margin-left: 20px;
    }
  }

  .r-wrapper {
    display: flex;
    align-items: center;
    font-size: 12px;
    padding-right: 20px;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      transition: .3s;
      cursor: pointer;
      margin: 0 20px;

      .iconfont {
        margin-right: 5px;
        color: @basic;
        font-size: 14px;
      }

      &:hover {
        color: @text-primary;
      }
    }

    .user {
      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        object-fit: cover;
      }

      span {
        margin-left: 5px;
        font-size: 12px;
      }
    }

    .user-box {
      position: relative;
      height: 40px;
      display: flex;
      align-items: center;

      &:hover {
        ul {
          display: block;
        }
      }

      ul {
        display: none;
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
        width: 100px;
        background: #fff;
        padding: 5px 10px;
        box-shadow: 0 2px 5px #eee;
        border-radius: 4px;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        color: #666;

        li {
          a {
            margin: 0;
            color: #666;
          }
        }

        li {
          cursor: pointer;
        }

        li + li {
          border-top: 1px solid @border-basic;
        }
      }
    }
  }
}

.nav {
  height: 54px;
  display: flex;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    height: 100%;
    color: #fff;
    font-size: 13px;
  }
}

.search-box {
  width: 160px;
  height: 36px;
  overflow: hidden;
  border-radius: 20px;
  background: #292929;
  position: relative;
  margin-right: 20px;

  input {
    width: 100%;
    height: 100%;
    background: transparent;
    border: none;
    padding-left: 16px;
    color: #fff;
  }

  .el-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
    color: #999999;
  }
}
.apply-wiki-btn{
  width: 106px;
  height: 36px;
  background: rgba(255,255,255,0.05);
  border-radius: 18px;
  border: 1px solid #525252;
  font-weight: 500;
  font-size: 13px;
  color: #DBDBDB;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 100px;
}

.msg-btn {
  position: relative;
  span {
    position: absolute;
    top: -6px;
    left: 20px;
    display: flex;
    align-items: center;
    padding: 0 4px;
    word-break: keep-all;
    background: red;
    border-radius: 10px;
    height: 16px;
    font-size: 12px;
    color: #fff;
  }
}
</style>
